// extracted by mini-css-extract-plugin
export default {"today-date":"components-hotel-pricing-assistant-table-cells-td-date-month-module__today-date"};